module.exports = __webpack_public_path__ + "static/media/PFC.c7768f98.jpg";